
<div class="baa_container">
  @if (isReady) {
    <div class="baa_title">{{ baaText['baa.title'] }}</div>

    <div class="baa_item baa_item--large">
      <div>{{ baaText['baa.preamble'] }}</div>
    </div>

    @for (section of sectionNumbers; track section) {
      <div class="baa_item baa_item--large">
        <div>{{ section }}.</div>
        <div><strong>{{ baaText['baa.' + section + '.title'] }}</strong> {{ baaText['baa.' + section + '.body'] }}</div>
      </div>
    }

    <div class="baa_item baa_item--large">
      <div class="text--pre-wrap">{{ baaText['baa.signatureBlock'] }}</div>
    </div>
  } @else if (loadFailed) {
    <div class="baa_item baa_item--large">
      <div>The agreement could not be loaded. Please check your connection and try again.</div>
    </div>
  }

  <br><br>

  <div class="flex-space-around">
    @if (loadFailed) {
      <button class="button button--primary button--border" (click)="loadBaaText()">
        <span class="regular">{{ 'tryAgain' | translate }}</span>
      </button>
    } @else {
      <button class="button button--primary button--border" [disabled]="!isReady || isLoading" (click)="onAgreementAccept()">
        <span class="regular">{{ 'accept' | translate }}</span>
      </button>
    }
    <button class="button button--secondary button--border" [disabled]="isLoading" (click)="onAgreementCancel()">
      <span class="regular">{{ 'cancel' | translate }}</span>
    </button>
  </div>

  <br>

  </div>

  @if (isLoading || (!isReady && !loadFailed)) {
    <app-loader [transparent]="true"></app-loader>
  }
